import { createSelector } from 'reselect';

import type { JobsStore } from './types';
import type { ReduxStore } from '../store';

const selectJobs = (state: ReduxStore): JobsStore => state.jobs;

export const getJobs = createSelector(selectJobs, (state) => state.jobs);

export const getJobTokens = createSelector(selectJobs, (state) => Object.keys(state.jobs));
